export default {
  saveInfo(params){
    return new Promise((resolve, reject) => {
      axios.post('/api/huodong/enroll',params)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    }) 
  },
    //活动详情
    getActiveInfo(params,id){
      return new Promise((resolve, reject) => {
        axios.get('/api/huodong/'+id+'/show',{
          params:params
        })
        .then((response) => {
          resolve(response)
        })
      }, err => {
        reject(err)
      })
    },
    //评论点赞
    setCommentPraise(params){
      return new Promise((resolve, reject) => {
        axios.post('/api/huodong/comment/praise',params)
        .then((response) => {
          resolve(response)
        })
      }, err => {
        reject(err)
      })
    },
    //活动评论
    getCommentList (id, params) {
      return new Promise((resolve, reject) => {
        axios.get('/api/huodong/' + id + '/comments',{
          params:params
        })
        .then((response) => {
          resolve(response)
        })
      }, err => {
        reject(err)
      })
    },
    //活动评论/回复
    Comment (params) {
      return new Promise((resolve, reject) => {
        axios.post('/api/huodong/comment',params)
        .then((response) => {
          resolve(response)
        })
      }, err => {
        reject(err)
      })
    },
    //活动收藏
    Collect(id, type){
      return new Promise((resolve, reject) => {
        axios.post('/api/huodong/follow',{
          hid:id, type:type
        })
        .then((response) => {
          resolve(response)
        })
      }, err => {
        reject(err)
      })
    },
    //评论删除
    delComment(id){
      return new Promise((resolve, reject) => {
        axios.delete('/api/bbs/card-comment/'+id+'/delete')
        .then((response) => {
          resolve(response)
        })
      }, err => {
        reject(err)
      })
    },
    getMyActive(params){
     return new Promise((resolve, reject) => {
      axios.get('/api/huodong/my',{
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
   },
   getRecommend(params){
    return new Promise((resolve, reject) => {
      axios.get('/api/user/recommend-user',{
        params:params
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
   },
   getRecommendLogin(){
    return new Promise((resolve, reject) => {
      axios.get('/api/user/recommend-login')
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    })
   }
 }